import React, { useState, useEffect, useCallback } from 'react'
import Modal from 'react-responsive-modal'

import DatePicker from 'react-datepicker'
import Select from 'react-select'
import moment from 'moment'
import SessionTableModify from './sessions-table-edit'
import SessionTable from './sessions-table-view'

const AdminActions = (Component) => {
  // if (typeof $app === 'undefined') {
  //   return props => <Component {...props} />
  // }
  // if (!$app.roles?.includes('mota')) {
  //   return props => <Component {...props} />
  // }

  return function AdminFormsProvider(props) {
    const [modal, setModal] = useState('')
    const [records, setRecords] = useState([])
    const [sessionNums, setSessionNums] = useState([])
    const [sessionNum, setSessionNum] = useState('')
    const [date, setDate] = useState('')
    const [filteredRecords, setfilteredRecords] = useState([])

    const getServiceName = useCallback(() => {
      if (props.service.name == 'bahama host company' || props.service.name == 'bahama host company client') {
        return 'bahama host company'
      }

      return props.service.name
    }, [props.service.name])

    const close = () => setModal('')

    useEffect(() => {
      async function getStudents() {
        const { data } = await $app.axios.get('/bahama_host_csps')

        const recs = [...data?.records, ...data?.records_by_proxy]

        setRecords(recs)
        setfilteredRecords(recs)
      }

      getStudents()
    }, [props.service.name])

    const actions = [
      {
        text: 'View List of Available Sessions',
        icon: 'school',
        test: $app.roles?.includes('officer'),
        fn: () => setModal('sessions'),
      },
      {
        text: 'Modify List Sessions',
        icon: 'edit',
        test: $app.roles?.includes('officer'),
        fn: () => setModal('sessions_modify'),
      },
      {
        text: 'View Class Register',
        icon: 'chalkboard-teacher',
        test: $app.roles?.includes('senior_officer'),
        fn: () => setModal('records'),
      },
    ]


    const on = {
      date_change: value => {
        setDate(value)
        setfilteredRecords(
          records.filter(rec =>
            sessionNum
              ? rec.session_numb == sessionNum &&
                moment(rec.session_date).format('MMMM Do YYYY') ==
                  moment(value).format('MMMM Do YYYY')
              : moment(rec.session_date).format('MMMM Do YYYY') ==
                moment(value).format('MMMM Do YYYY')
          )
        )
      },

      num_change: value => {
        setSessionNum(value?.value)
        setfilteredRecords(
          records.filter(rec =>
            date
              ? rec.session_numb == value?.value &&
                moment(rec.session_date).format('MMMM Do YYYY') ==
                  moment(date).format('MMMM Do YYYY')
              : rec.session_numb == value?.value
          )
        )
      },
    }

    const modalContent = heading => (
      <div style={{ maxWidth: '100%', maxHeight: '100%' }}>
        <div className='modal-header'>
          <h4>{heading}</h4>
          {modal === 'records' && <Filters />}
        </div>
        <div
          className='modal-body overflow-y-scroll divide-y divide-gray-400'
          style={{ maxHeight: '50vh' }}
        >
          {modal === 'sessions' && <SessionTable getServiceName={getServiceName} closeModal={close} setSessionNums={setSessionNums} />}
          {modal === 'sessions_modify' && <SessionTableModify getServiceName={getServiceName} closeModal={close} />}
          {modal === 'records' && Records}
        </div>
      </div>
    )

    const Filters = () => {
      return (
        <div className='form-group row'>
          <label
            htmlFor='session_numb'
            className='col-md-2 col-sm-4 mt-sm-2 text-right'
          >
            Session #
          </label>
          <div className='col-md-4'>
            {' '}
            <Select
              name='session_numb'
              key={sessionNum}
              options={sessionNums}
              // values={[sessionNums.find(s => s.value == sessionNum) || {}]}
              defaultValue={sessionNums.find(s => s.value == sessionNum) || {}}
              onChange={on.num_change}
              className='form-control'
            />
          </div>
          <label
            htmlFor='session_numb'
            className='col-md-3 col-sm-4 mt-sm-2 text-right'
          >
            Session Date
          </label>
          <div className='col-md-3'>
            {' '}
            <DatePicker
              type='date'
              className='form-control'
              name={'date'}
              onChange={on.date_change}
              selected={date}
              value={date}
              dateFormat='MMMM d, yyyy'
            />
          </div>
        </div>
      )
    }

    const Records = filteredRecords.map((r, i) => (
      <div
        key={i}
        className='flex flex-row justify-between items-center rounded-md my-2 p-2 hover:bg-gray-200 cursor-pointer'
      >
        <div>
          {r?.user.first_name.capitalize()} {r?.user.last_name.capitalize()}
          <br />
          <em>
            {r?.industry_type}
            {/* <span className='text-gray-600'>({p.port_type})</span> */}
          </em>
        </div>
      </div>
    ))

    return (
      <React.Fragment>
        <Component {...props} admin_actions={actions} />
        <Modal
          open={modal == 'sessions'}
          onClose={close}
          center
          styles={{ modal: { maxWidth: '1200px', width: '90%', position: 'relative' } }}
        >
          {modalContent('List of Available Sessions')}
        </Modal>
        <Modal
          open={modal == 'sessions_modify'}
          onClose={close}
          center
          styles={{ modal: { maxWidth: '1480px', width: '90%', position: 'relative' } }}
        >
          {modalContent('Modify Sessions')}
        </Modal>
        <Modal
          open={modal == 'records'}
          onClose={close}
          center
          styles={{ modal: { width: '1500px' } }}
        >
          {modalContent('Class Register')}
        </Modal>
      </React.Fragment>
    )
  }
}

export default AdminActions
